<template>
  <div>

    <div class="card-body">
      <div class="tab-content">
        <div class="tab-pane active" id="activity">

          <div class="row">
            <div class="col-md-12">
              <h5 class="h4-t">Document</h5>
              <hr />
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm">
                  <thead class="bg-info">
                    <tr>
                      <th>Document Type</th>
                      <th>Description</th>
                      <th style="width: 10px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in documents">
                      <td>{{item._DocumentType}}</td>
                      <td>{{item.Description}}</td>
                      <td style="white-space: nowrap">
                        <!--<button class="btn btn-sm btn-info" v-on:click="showDocumentModal(item, ind)"><i class="fas fa-edit"></i></button>-->
                        <button class="btn btn-sm btn-success" v-on:click="viewFile(item.FileName)"><i class="fas fa-image"></i></button>
                        <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteDocument" v-on:click="documentIndex = ind;"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">
                        <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showDocumentModal()">Add New</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.tab-content -->
    </div>

    <div class="card-footer">
      <a class="btn btn-primary" href="../Employees/List">Back to List</a>
      <div class="float-right">
        <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
        <!--<input type="submit" value="Save Profile" class="btn btn-success  " />-->
      </div>
    </div>

    <div class="modal fade" id="modalDocument">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Document</h4>
          </div>

          <form id="document" v-on:submit="saveDocument">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Document Type *</label>
                    <select class="form-control" v-model="document.DocumentTypeID" required>
                      <option value="">--Select--</option>
                      <option v-for="item in documentTypes" :value="item.DocumentTypeID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Document *</label>
                    <div>
                      <input type="file" id="attachment" v-on:change="onfileupload">
                    </div>
                    <small>Max size is 1 mb</small>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Description</label>
                    <input class="form-control" type="text" v-model="document.Description" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modalDeleteDocument">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <h3>Are you sure you want to delete this record ?</h3>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" v-on:click="deleteDocument()" class="btn btn-danger">Delete</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

  </div>
</template>

<script>

  $(document).ready(function () {
    $('[data-mask]').inputmask()
  });

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        documents: [],
        document: { EmployeeDocumentID: 0, DocumentTypeID: '', Attachment: '', Description: '', ImageBase64: '' },
        documentIndex: -1,
        documentTypes: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/EmployeesApi/pageLoadDocument?id=' + vm.employeeId)
          .then(function (res) {
            endReq();

            vm.documentTypes = res.data.documentTypes;

            if (res.data.documents)
              vm.documents = res.data.documents;
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      showDocumentModal(data, index) {
        if (data) {
          this.document = Object.assign({}, data);
          this.documentIndex = index
        }
        else {
          this.document = { EmployeeDocumentID: 0, DocumentTypeID: '', Attachment: '', Description: '', ImageBase64: '' };
          this.documentIndex = -1;
        }

        $('#modalDocument').modal('show');
      },

      saveDocument(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/saveEmployeeDocument?id=' + vm.employeeId, {
          document: vm.document
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              if (vm.documentIndex == -1)
                vm.documents.push(res.data.document);
              else {
                vm.documents[vm.documentIndex] = res.data.document;
                vm.documentIndex = -1;
                $('#modalDocument').modal('hide');
              }
              vm.document = { EmployeeDocumentID: 0, DocumentTypeID: '', Attachment: '', Description: '', ImageBase64: '' };
            }
            else
              toastr.error(res.data.msg);

          }).catch(function (err) {
            endReq();
            var res = err.response;
            if (res.status == 401) {
              toastr.error(res.data);
            }
            else {
              for (const [key, value] of Object.entries(res.data.errors)) {
                toastr.error(`${value}`);
              }
            }
          })
      },

      deleteDocument() {
        var vm = this;
        startReq();
          axios.get('/api/EmployeesApi/deleteEmployeeDocument?id=' + vm.documents[vm.documentIndex].EmployeeDocumentID)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Deleted Successfully", "Done!");
              vm.documents.splice(vm.documentIndex, 1);
              vm.documentIndex = -1;
              $('#modalDeleteDocument').modal('hide');
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      checkFile(file) {

        if (file == null) {
          return false;
        }

        if (file.size > 1000000) {
          toastr.error("file size is large maximum 1 mb is allowed", "Error!");

          return false;
        }

        if (file.type != "image/jpeg" && file.type != "image/png") {
          toastr.error("Invalid File! only JPG and PNG is allowed");
          return false;
        }

        return true;
      },

      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.document.ImageBase64 = e.target.result
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#attachment').val('');
        }
      },

      downloadDocument(id) {
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/downloadFile?id=' + id)
          .then(function (res) {
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      viewFile(name) {
        var vm = this;
        startReq();
          axios.post('/api/EmployeesApi/viewEmployeeFile?name=' + name)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              var newTab = window.open();
              newTab.document.body.innerHTML = '<img src="' + res.data.file + '" >';
            }
            else
              toastr.info(res.data.msg);
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      clear() {
        location.reload();
      }
    }
  })
</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/hr/employeeDocument.vue